<div style="max-width: auto; overflow: auto;">
  <app-common-list-table [request]="getRequest" [cols]="cols" [globalConditionalStyle]="globalConditionalStyle"
    [globalVisualTransform]="globalVisualTransform" [selectionMode]="tableMode()" [filtering]="filter"
    [actionButtonText]="canAddParcelas ? btnAnadir : ''" (actionButtonClick)="add()" (emitSearchText)="updateFooter()"
    [customExportCsv]="showBotonPrintParcelas" (visualize)="show('info', $event)" (edit)="edit($event)"
    (duplicate)="duplicate($event)" (remove)="show('delete', $event)" (rowClick)="getSelectedNodes($event)">

    <ng-template #center>
     
    </ng-template>

    <ng-template #tdEnd let-data>
      <td *ngIf="this.appName === 'agrosalvi'">
        <div class="col col-md-1 col-offset-1">
          <button class="btn btn-warning" style="margin-left:0px !important" (click)="abreMapa(data);">
            <i class="fa fa-search" aria-hidden="true"></i>
            <span> Mapa</span>
          </button>
        </div>
      </td>
      <td>
        <div class="d-flex justify-content-center align-items-center">
          <app-action-buttons [showDuplicate]="this.rol !== 'responsable'"
            (duplicateRowButtonEvent)="duplicate(data.data)" [hideEdit]="!canEditParcelas"
            [hideDelete]="!canDeleteParcelas" (editRowButtonEvent)="edit(data.data)"
            (deleteRowButtonEvent)="show('delete', data.data)" (showRowButtonEvent)="show('info', data.data)">
          </app-action-buttons>

        </div>
      </td>
    </ng-template>

    <ng-template #header>
      @if (appName === 'avafitogest') {
      <button class="btn btn-sm btn-primary text-white align-self-center text-nowrap" (click)="openDocumentInNewTab()">
        Obligación GIP
      </button>
      <button class="btn btn-sm btn-primary text-white align-self-center text-nowrap" (click)="activatedAssignToResponsible()">
        {{ multiSelect() ? 'Desactivar Asignacion' : 'Activar Asignacion' }}
      </button>

      <button *ngIf="selectParcelas().length > 0" class="btn btn-sm btn-secondary text-white align-self-center text-nowrap" (click)="openAssignToResponsible()">
        Asignar Responsable a seleccionados
      </button>
      }
    
      <button class="btn align-self-center text-white" (click)="downloadCsv()"
        style="font-size: .8rem;  background-color: #16A2B7;">
        <i class="fa fa-download"></i>
        Exportar listado
      </button>
    
      <div class="d-flex justify-center align-content-center gap-2">
        <div *ngIf="showCampaign" id="year_campaign" style="width: 15rem !important;" class="d-flex justify-content-center">
          <label for="">Año</label>
          <p-select placeholder="{{selectedYears}}" [options]="years" [(ngModel)]="selectedYears"
            (onChange)="selectedCampaign($event.value)">
          </p-select>
        </div>
        <div class="d-flex flex-column">
          <small>
            Superficie total (SigPAC): <b>{{totalSupSigpac || 0}} {{textoSuperficie}}</b>
          </small>
          <small>
            Superficie total (cultivada): <b>{{totalSupCultivada || 0}} {{textoSuperficie}}</b>
          </small>
        </div>
      </div>
    </ng-template>

    <ng-template #thEnd>
      <th *ngIf="this.appName === 'agrosalvi'">
        <p class="d-flex justify-content-center" style="margin-bottom: 0">Mapa</p>
      </th>
      <th style="width: 120px;">
        <p class="mb-0 d-flex justify-content-center">Acciones</p>
      </th>
    </ng-template>

    <ng-template #tdEnd let-data>
      <td>
        <app-action-buttons (editRowButtonEvent)="edit(data)" (deleteRowButtonEvent)="show('delete', data)"
          (showRowButtonEvent)="show('info', data)">
        </app-action-buttons>
      </td>
    </ng-template>

    <ng-template #footer let-col>
      <div style="font-size: 0.75em; text-align: left" *ngIf="(['finca'].includes(col.field))">
        TOTAL:
      </div>
      <div *ngIf="(['superficie_sigpac', 'superficie_cultivada'].includes(col.field))"
        style="font-size: 0.75em; text-align: right; font-weight: bold; padding-right: 34px">
        {{col?.footer || 0}}
      </div>
    </ng-template>
  </app-common-list-table>
</div>

<p-dialog *ngIf="canShow['info']" header="Detalle del registro" [(visible)]="canShow['info']" (onShow)="scrollToTop()">

  <div style="width: 80vw !important">
    <h4>Datos {{parcelaName}}</h4>
    <app-form-builder [model]="model" [distributionColumns]="4" [distributionOrder]="hasPlantas ? [2, 4, 4, 2] : [4]"
      [fields]="formFieldsDatosParcela">
    </app-form-builder>
    <br>
    <br>
    <h4>Datos SigPAC</h4>
    <app-form-builder [model]="model" [distributionColumns]="4" [fields]="formFieldsDatosSigpac">
    </app-form-builder>
    <br>
    <br>
    <h4>Datos generales</h4>
    <app-form-builder [model]="model" [distributionColumns]="4" [fields]="formFieldsDatosGenerales">
    </app-form-builder>
    <br>
    <div *ngIf="showDatosMedioambientales">
      <h4>Puntos de captación de agua</h4>
      <app-form-builder [model]="model" [distributionColumns]="4" [fields]="formFieldsDatosMedioambientales">
      </app-form-builder>
      <br>

      <h4>Parcelas en zonas específicas</h4>
      <app-form-builder [model]="model" [distributionColumns]="4" [fields]="formFieldsZonasEspecificas">
      </app-form-builder>
      <br>
    </div>
    <br>
    <div class="d-flex justify-content-center">
      <button class="btn btn-dark mx-2" (click)="hide('info')">Cerrar</button>
    </div>
  </div>
  <br>

</p-dialog>

<p-dialog *ngIf="canShow['delete']" header="Eliminar registro" [(visible)]="canShow['delete']" (onShow)="scrollToTop()">

  <div style="width: 80vw !important">
    <h4>Datos Parcela</h4>
    <app-form-builder [model]="model" [distributionColumns]="4" [fields]="formFieldsDatosParcela">
    </app-form-builder>
    <br>
    <br>
    <h4>Datos SigPAC</h4>
    <app-form-builder [model]="model" [distributionColumns]="4" [fields]="formFieldsDatosSigpac">
    </app-form-builder>
    <br>
    <br>
    <h4>Datos generales</h4>
    <app-form-builder [model]="model" [distributionColumns]="4" [fields]="formFieldsDatosGenerales">
    </app-form-builder>
    <br>
    <div class="d-flex justify-content-center">
      <button class="btn btn-dark mx-2" (click)="hide('delete')">Cerrar</button>
      <app-request-button (click)="deleteRegister()" [request]="deleteRequest" [mode]="deleteRequestButtonType">
      </app-request-button>
    </div>
    <br>
    <p *ngIf="deleteRequest.hasError === undefined && !deleteRequest.isLoading" style="color: red; text-align: center">
      ¿Está seguro de eliminar este registro?
    </p>
  </div>
  <br>

</p-dialog>



<p-dialog [header]="'Mapa ' + parcelaName" [(visible)]="mapaAbierto" #mapaDialog (onShow)="scrollToTop()">

  <div *ngIf="mapaAbierto" style="height:86%; margin-left:20px; margin-right:20px; width: 80vw !important">
    <app-mapa-add [origin]="origin" [finca]="finca" [localidad]="localidad" [cultivo]="cultivo" [variedad]="variedad"
      [parcelaNombre]="parcelaNombre" [coordenadas]="coordenadas" (fromMapa)="getFromMapa($event)">
    </app-mapa-add>
  </div>
  <br>

</p-dialog>

<p-dialog #dialogAsign header="Asignar Responsable" [(visible)]="assignToResponsibleOpened" [modal]="true" (onShow)="getUsersList()" 
  [style]="{'height': '80vh'}">
  <ng-template #header>
    <span class="bg-gray-500 px-2"> <b>{{selectParcelas().length}}</b> &nbsp;Parcelas seleccionadas </span>
  </ng-template>
  
  <div class="d-flex align-content-between justify-content-between flex-column overflow-hidden h-100">
    <div>
      <small>Seleccione un responsable para la(s) parcela(s) seleccionada(s):</small>
      <p-select [options]="responsables()" [filter]="true" [optionLabel]="'nombre'" [optionValue]="'id'" [(ngModel)]="selectedResponsable"></p-select>
    </div>

    <button class="btn btn-primary" [disabled]="selectedResponsable === null" (click)="assignToResponsible()">Asignar</button>

  </div>
  <ng-template #footer>
    <div class="d-flex justify-content-end">
      <button class="btn btn-secondary" (click)="openAssignToResponsible()">
        Cerrar
      </button>
    </div>
  </ng-template>
  
</p-dialog>
